import { render, staticRenderFns } from "./TrainingCourse.vue?vue&type=template&id=4ede3aaf&scoped=true&"
import script from "./TrainingCourse.vue?vue&type=script&lang=js&"
export * from "./TrainingCourse.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCourse.vue?vue&type=style&index=0&id=4ede3aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede3aaf",
  null
  
)

export default component.exports